import React, { useEffect, useState } from 'react'
import { AiOutlineMenuUnfold } from "react-icons/ai";
import { AiOutlineMenuFold } from "react-icons/ai";
import { PiStudentDuotone } from "react-icons/pi";
import { FaRegBookmark } from "react-icons/fa";
import { VscGitPullRequestGoToChanges } from "react-icons/vsc";
import { CiViewBoard } from "react-icons/ci";
import { IoSettingsOutline } from "react-icons/io5";
import { FaRegUser } from "react-icons/fa";
import { IoMdLogOut } from "react-icons/io";

//images
// import login_page from "../assets/login_page.jpg"
import logo_img from "../assets/logo.jpg"
import srjlogo from "../assets/srjlogo.png"
import { Link } from 'react-router-dom'
import { API } from './constant'
import axios from 'axios'

const Header = () => {

  const userLogout = () => {
    localStorage.clear()
    window.location.href = "/"
  }

  // get logged in user details start 
  const [loggedinName, setLoggedinName] = React.useState("")
  const [loggedinRole, setLoggedinRole] = React.useState("")
  const [loggedinSchoolLocation, setLoggedinSchoolLocation] = React.useState("")
  const [loggedinPermission, setLoggedinPermission] = React.useState([])

  useEffect(() => {
    axios.get(`${API}/login/logged-in-user`, {
      headers: {
        "Content-Type": "application/json",
        "token": localStorage.getItem("token")
      }
    })
      .then((res) => {
        // console.log(res)
        setLoggedinName(res.data.data.name)
        setLoggedinRole(res.data.data.role)
        // localStorage.setItem("role",res.data.data.role)
        setLoggedinSchoolLocation(res.data.data.school_location)
        setLoggedinPermission(res.data.data.permission)
      })
      .catch((err) => {
        // console.log(err);
        if (err.response) {
          // Handle invalid token
          if (err.response.status === 401) {
            localStorage.removeItem("token");
            // history.push('/');
            window.location.href = "/"
          }
          // Handle token expiration
          else if (err.response.status === 302) {
            window.location.href = "/"

          }
        }
      });
  }, [])
  // get logged in user details end 


  //==================== mobile menu start ========================
  const [mobileMenu, setmobileMenu] = useState(false)

  const handleMobileMenu = () => {
    setmobileMenu(true)
  }
  //==================== mobile menu end ========================



  return (
    <div className=''>
      <div className='fixed top-0 w-full ' >
        <div className='w-full bg-[#8321A8] py-[2px] px-[10px] sm:py-[5px] flex justify-between items-center sm:px-[20px] h-[10vh]'>
          <Link to="/" className='sm:block hidden'>
            <div className='bg-white h-[8vh]'>
              {/* <img className='w-[250px]' src={logo_img} alt="" /> */}
              <img className='w-[250px] h-[100%]' src={srjlogo} alt="logo" />
            </div>
          </Link>
          <div className=' block sm:hidden'>
            <AiOutlineMenuUnfold onClick={handleMobileMenu} className={`${mobileMenu ? "hidden" : "block"}`} />
          </div>
          <div >
            <div className='bg-[#1B1B1B] text-white px-[10px] py-[5px] sm:px-[20px] sm:py-[10px] font-semibold text-[10px] sm:text-[20px] rounded-md'>
              <h3>Welcome {loggedinName}, {loggedinSchoolLocation}</h3>
            </div>
          </div>
          <div className='flex gap-3'>
            <div className='bg-[#1B1B1B] text-white px-[10px] sm:px-[20px] py-[5px] sm:py-[10px] font-semibold text-[10px] sm:text-[15px] rounded-md'>
              <h3>{loggedinRole}</h3>
            </div>
            <div onClick={userLogout} className='hidden sm:block cursor-pointer bg-[#1B1B1B] text-white px-[20px] py-[10px] font-semibold text-[15px] rounded-md'>
              <h3>Logout</h3>
            </div>
          </div>
        </div>

        {/* previous menu start  */}
        <div className=' hidden sm:flex w-full bg-[#1B1B1B] py-[5px]  justify-between items-center px-[20px] sm:h-[10vh]'>
          <div >
          </div>
          <div className='flex justify-between items-center gap-4'>
            {
              loggedinRole === "Admin" || loggedinRole === "Teacher" || loggedinRole === "Super Admin" ? (

                <Link to="/students" >
                  <div className='hover:border-b-[2px] ]border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                    Students
                  </div>
                </Link>
              ) : null

            }
            {
              loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (
                <Link to="/add-paragraph">
                  <div className='hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                    Paragraphs
                  </div>
                </Link>
              ) : null
            }
            {
              loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (
                <Link to="/questions">
                  <div className='hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                    Questions
                  </div>
                </Link>
              ) : null
            }
            <Link to="/view">
              <div className='hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                View
              </div>
            </Link>


            {
              loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (
                <Link to="/master">
                  <div className='hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                    Masters
                  </div>
                </Link>
              ) : null
            }
            {
              loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (
                <Link to="/reports">
                  <div className='hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                    Reports
                  </div>
                </Link>
              ) : null
            }
            {
              loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (
                <Link to="/users">
                  <div className='hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                    Users
                  </div>
                </Link>
              ) : null
            }
          </div>
        </div>
        {/* previous menu start  */}


        {/* mobile menu start  */}
        <div className='' onClick={() => setmobileMenu(false)}>
          {
            mobileMenu && (
              <div className='inset-0 z-10  fixed w-[60vw] h-full bg-black '>
                <div className='flex justify-end bg-white'>
                  <AiOutlineMenuFold onClick={() => setmobileMenu(false)} size={30} />
                </div>
                <div className='w-full h-[20vh] flex items-center bg-white'>
                  <Link to="/" className=''>
                    <div className='bg-white h-[8vh]'>
                      <img className='w-[250px]' src={logo_img} alt="" />
                      {/* <img className='w-[250px] h-[100%]' src={srjlogo} alt="logo" /> */}
                    </div>
                  </Link>

                </div>
                <div className=''>
                  {
                    loggedinRole === "Admin" || loggedinRole === "Teacher" || loggedinRole === "Super Admin" ? (

                      <Link to="/students" >
                        <div className='flex items-center gap-2 border-b-[1px] hover:border-b-[2px] ]border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                          <span><PiStudentDuotone /></span><span>Students</span>
                        </div>
                      </Link>
                    ) : null

                  }
                  {
                    loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (
                      <Link to="/add-paragraph">
                        <div className='flex items-center gap-2 border-b-[1px] hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                          <span><FaRegBookmark /></span><span>Paragraphs</span>
                        </div>
                      </Link>
                    ) : null
                  }
                  {
                    loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (
                      <Link to="/questions">
                        <div className='flex items-center gap-2 border-b-[1px] hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                          <span><VscGitPullRequestGoToChanges /></span><span>Questions</span>
                        </div>
                      </Link>
                    ) : null
                  }
                  <Link to="/view">
                    <div className='flex items-center gap-2 border-b-[1px] hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                      <span><CiViewBoard /></span><span>View</span>
                    </div>
                  </Link>


                  {
                    loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (
                      <Link to="/master">
                        <div className='flex items-center gap-2 border-b-[1px] hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                          <span><IoSettingsOutline /></span><span>Masters</span>
                        </div>
                      </Link>
                    ) : null
                  }
                  {
                    loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (
                      <Link to="/users">
                        <div className='flex items-center gap-2 border-b-[1px] hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                          <span><FaRegUser /></span><span>Users</span>
                        </div>
                      </Link>
                    ) : null
                  }
                  <div onClick={userLogout} className='flex items-center gap-2 border-b-[1px] hover:border-b-[2px] ] border-white cursor-pointer py-[8px] text-white px-[8px]  font-semibold text-[18px] tracking-wider'>
                    <span><IoMdLogOut  /></span><span>Logout</span>
                  </div>
                </div>

              </div>
            )
          }


        </div>
        {/* mobile menu end */}



      </div>
    </div>
  )
}

export default Header


